export default __webpack_public_path__ + "static/media/cover_1.8e94f800.jpg";